import React from 'react';
import ReactDOM from 'react-dom/client';
import './v32/schoolUsage.css';
import './v32/examFeedback.css';

const root=document.getElementById('root');
if(!root) throw new Error('Chrona root element not found');

const hostname=window.location.hostname.toLowerCase();
const pathname=window.location.pathname.replace(/\/+$/,'')||'/';
const publicExamHost=hostname==='timer.chronaedu.com';
const previewExamPath=hostname.endsWith('.chrona-school-platform.pages.dev')&&hostname!=='chrona-school-platform.pages.dev'&&pathname==='/timer-preview';
const legacyExamPath=hostname==='chrona-school-platform.pages.dev'&&pathname==='/exam-timer';

if(legacyExamPath){
  window.location.replace('https://timer.chronaedu.com');
}else{
  const entry=publicExamHost||previewExamPath||pathname==='/exam-timer'?import('./publicExamEntry'):import('./appEntry');
  entry.then(({default:RootComponent})=>{
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <RootComponent/>
      </React.StrictMode>,
    );
  }).catch(error=>{
    console.error('Chrona failed to start',error);
    root.innerHTML='<main style="font-family:system-ui,sans-serif;padding:40px;color:#23324d"><h1>Chrona could not start</h1><p>Please refresh the page. If the problem continues, contact your Chrona administrator.</p></main>';
  });
}
